import Header from '../Header1';
import "../../styles/grid.css";
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from '../../axiosInstance';
import formula_icon from "../../assets/svg/formula-icon.svg"
import plus_icon from "../../assets/svg/plus_icon.svg";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import "../../styles/TemplateCreation.css";
import subcostlinearrow from "../../assets/svg/subCostline_arrow.svg"
import { selectCategory, addElement, updateElement, setCategories, deleteElement, resetCategories, pasteCategoryElements } from "../../Redux/CategorySlice";
import Select from 'react-select';
import CommonFooter from '../../CommonFooter/CommonFooter';
import three_dots from "../../assets/svg/Dots.svg";
import { X } from 'lucide-react';
import delete_icon from "../../assets/svg/delete_icon.svg";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

const TemplateCreation = () => {
  const navigate = useNavigate();
  const [modelOptions, setModelOptions] = useState([]);
  const [projectPeriodOptions, setProjectPeriodOptions] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedProjectPeriod, setSelectedProjectPeriod] = useState("");
  const [expandedCategory, setExpandedCategory] = useState(null);
  const categories = useSelector((state) => state.category.categories);
  const selectedCategoryIndex = useSelector((state) => state.category.selectedCategoryIndex);
  const dispatch = useDispatch();
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingData, setEditingData] = useState({});
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [tooltip, setTooltip] = useState({ visible: false, content: '', position: { x: 0, y: 0 } });
  const [templateName, setTemplateName] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");
  const [projectPeriod, setProjectPeriod] = useState("");
  const [selectedProjectPeriodDetails, setSelectedProjectPeriodDetails] = useState(null);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [pendingDeleteIndex, setPendingDeleteIndex] = useState(null);
  const [copiedCategoryData, setCopiedCategoryData] = useState(() => {
    try {
      const stored = sessionStorage.getItem('template_copiedCategoryData');
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      console.error('Failed to restore copied category data:', err);
      return null;
    }
  });


  const [categoryDropdownVisibleFor, setCategoryDropdownVisibleFor] = useState(null);

  const tooltipStyle = {
    position: 'fixed',
    fontSize: '12px',
    left: `${tooltip.position.x}px`,
    top: `${tooltip.position.y}px`,
    backgroundColor: '#2d3748',
    color: '#fff',
    borderRadius: '4px',
    padding: '8px 12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    zIndex: 9999,
    display: tooltip.visible ? 'block' : 'none',
    pointerEvents: 'none',
    maxWidth: '300px',
    whiteSpace: 'pre-wrap',
    lineHeight: '1.4',
  };

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const handleProjectPeriodChange = (selected) => {
    setProjectPeriod(selected?.value);
    if (selected) {
      const periodDetails = projectPeriodOptions.find(option => option.value === selected.value);
      setSelectedProjectPeriodDetails(periodDetails);
    } else {
      setSelectedProjectPeriodDetails(null);
    }
  };




  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axiosInstance.get(`/costsolution/model/getModel`);
        console.log("Model API response:", response.data);

        if (response.data && Array.isArray(response.data.model)) {
          setModelOptions(response.data.model); // ← Use it directly
        }
      } catch (error) {
        console.error("Failed to fetch models:", error);
      }
    };

    fetchModel();
  }, []);

  useEffect(() => {
    const fetchProjectPeriod = async () => {
      try {
        const response = await axiosInstance.get(`/costsolution/projectperiod?skip=0&limit=1000`);
        if (response.data && Array.isArray(response.data.projectPeriod)) {
          const formattedOptions = response.data.projectPeriod.map(item => ({
            value: item.id,
            label: item.name,
            period: item.period,
            period_type: item.period_type,
            break_period_value: item.break_period_value
          }));
          setProjectPeriodOptions(formattedOptions);
        }
      } catch (error) {
        console.error("Failed to fetch Project Period:", error);
      }
    };

    fetchProjectPeriod();
  }, []);



  useEffect(() => {
    if (selectedModel) {
      const fetchCategories = async () => {
        try {
          const response = await axiosInstance.get(
            `/costsolution/templatecostlines/category/${selectedModel}`
          );
          console.log("Categories API response:", response.data);

          if (response.data && Array.isArray(response.data.category)) {
            const categoriesWithElements = response.data.category.map(cat => ({
              ...cat,
              elementlist: []
            }));
            dispatch(setCategories(categoriesWithElements));
          }
        } catch (error) {
          console.error("Failed to fetch categories:", error);
        }
      };

      fetchCategories();
    }
  }, [selectedModel]);

  const toggleCategory = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  const handleSubcostlineArrowClick = (e, field, element, subIndex) => {
    e.stopPropagation();
    if (!validateMandatoryFields()) return;

    const existingSetupRaw = field === 'quantity' ? element.quantitySetup : element.rateSetup;
    let existingRows = [];
    if (existingSetupRaw) {
      try {
        existingRows = typeof existingSetupRaw === 'string'
          ? JSON.parse(existingSetupRaw)
          : existingSetupRaw;
      } catch (err) {
        console.error('Failed to parse existing setup rows:', err);
        existingRows = [];
      }
    }

    sessionStorage.setItem('popupState', JSON.stringify({
      isOpen: true,
      editingIndex: subIndex,
      editingData: element
    }));

    const subcostData = {
      field,
      element,
      rowType: location.state?.templateId ? 'existing' : 'new',
      rowIdentifier: location.state?.templateId || subIndex,
      categoryIndex: selectedCategoryIndex,
      elementIndex: subIndex,
      templateName,
      model: selectedModel,
      date: effectiveDate,
      projectPeriod,
      projectPeriodDetails: selectedProjectPeriodDetails,
      categories,
      existingRows
    };

    sessionStorage.setItem('subcostNavigationData', JSON.stringify(subcostData));
    sessionStorage.setItem('subcostFlowActive', 'true');
    navigate('/TemplateSubcostline');
  };

  useEffect(() => {
    const handleReturnFromSubcost = () => {
      const returnData = sessionStorage.getItem('subcostReturnData');
      if (!returnData) return;

      try {
        const parsedData = JSON.parse(returnData);

        if (!parsedData.field || !parsedData.element || parsedData.categoryIndex === undefined) {
          console.error('Error processing return data: Missing required fields');
          return;
        }

        const updatedElement = calculateDerivedFields({
          ...parsedData.element,
          [parsedData.field]: parsedData.calculatedValue,
          ...(parsedData.field === 'quantity'
            ? { quantitySetup: JSON.stringify(parsedData.rows || []) }
            : { rateSetup: JSON.stringify(parsedData.rows || []) })
        });

        dispatch(updateElement({
          categoryIndex: parsedData.categoryIndex,
          elementIndex: parsedData.elementIndex,
          element: updatedElement
        }));

        if (parsedData.templateName) setTemplateName(parsedData.templateName);
        if (parsedData.model) setSelectedModel(parsedData.model);
        if (parsedData.date) setEffectiveDate(parsedData.date);
        if (parsedData.projectPeriod) setProjectPeriod(parsedData.projectPeriod);

        if (parsedData.projectPeriodDetails) {
          setSelectedProjectPeriodDetails(parsedData.projectPeriodDetails);
        }

        const popupState = JSON.parse(sessionStorage.getItem('popupState') || 'null');
        if (popupState?.isOpen) {
          setShowPopup(true);
          setEditingIndex(popupState.editingIndex);
          setEditingData(updatedElement);
        }

        sessionStorage.removeItem('subcostReturnData');
        sessionStorage.removeItem('popupState');
        sessionStorage.removeItem('subcostFlowActive');
      } catch (error) {
        console.error('Error processing return data:', error);
      }
    };

    handleReturnFromSubcost();
  }, [dispatch]);

  useEffect(() => {
    const restoreOnCancelledReturn = () => {
      if (sessionStorage.getItem('subcostReturnData')) return;

      const navData = sessionStorage.getItem('subcostNavigationData');
      if (!navData) return;

      try {
        const parsedNav = JSON.parse(navData);
        if (parsedNav.templateName) setTemplateName(parsedNav.templateName);
        if (parsedNav.model) setSelectedModel(parsedNav.model);
        if (parsedNav.date) setEffectiveDate(parsedNav.date);
        if (parsedNav.projectPeriod) setProjectPeriod(parsedNav.projectPeriod);
        if (parsedNav.projectPeriodDetails) setSelectedProjectPeriodDetails(parsedNav.projectPeriodDetails);
      } catch (err) {
        console.error('Failed to restore data after cancelled Sub Cost Line visit:', err);
      } finally {
        // NEW — consume it, whether restore succeeded or not, so it can't leak into a future mount
        sessionStorage.removeItem('subcostNavigationData');
        sessionStorage.removeItem('subcostFlowActive');
      }
    };

    restoreOnCancelledReturn();
  }, []);


  useEffect(() => {
    const isReturningFromSubcost = sessionStorage.getItem('subcostFlowActive') === 'true';

    if (!isReturningFromSubcost) {
      sessionStorage.removeItem('subcostNavigationData');
      sessionStorage.removeItem('subcostReturnData');
      sessionStorage.removeItem('popupState');
    }
  }, []);

  const handleFormulaHover = (content, e) => {
    const tooltipWidth = 300;
    const tooltipHeight = 150;
    const offset = 10;

    let x = e.clientX;
    let y = e.clientY;

    if (x + tooltipWidth + offset > window.innerWidth) {
      x = window.innerWidth - tooltipWidth - offset;
    }

    if (y + tooltipHeight + offset > window.innerHeight) {
      y = window.innerHeight - tooltipHeight - offset;
    }

    setTooltip({
      visible: true,
      content,
      position: { x, y }
    });
  };

  const handleFormulaLeave = () => {
    setTooltip({ ...tooltip, visible: false });
  };

  const FORMULAS = {
    WI_RATE: "WI Rate % = (Work Interest Rate) as defined in contract",
    COST_ESCALATION_PERCENTAGE: "Cost Escalation Percentage / Month",
    CAPEX_INTEREST_RATE: "Capex Interest Rate / Month ",
    CAPEX_MAINTENANCE: "Capex Maintenance / Month",
    CAPEX_INSURANCE: "Capex Insurance/ Month",
    BASIC_COST_VALUE: "(Quantity × Rate) / Cost period",
    COST_ESCALATION: "((Quantity × Rate) / Cost period) * (Cost escalation / 100)",
    CAPEX_COST_INTEREST: "Capex Cost Interest = (Capex × Interest Rate × Time) / 100",
    COST_MAINTENANCE: "((Quantity × Rate) * capex maintenance / 100)) / 12",
    COST_INSURANCE: "((Quantity × Rate) * capex maintenance / 100)) / 12",
    COST_BUFFER: "(Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance)*(Buffer Rate / 100)",
    COST_MARGIN: "(Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance + Cost Buffer) * ( Margin Rate / 100 )",
    COST_WI: "(Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance + Cost Buffer ) * (WI Rate / 100)",
    COST_WITH_BUFFER_MONTH: "Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance +Cost Buffer + Cost Margin",
    COST_WITHOUT_BUFFER_MONTH: "Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance + Cost Margin",
    COST_WITH_BUFFER_PERIOD: "Cost with Buffer (month) * period",
    COST_WITHOUT_BUFFER_PERIOD: "Cost W/O Buffer (month) * period"
  };

  const calculateDerivedFields = (data) => {
    const updatedData = { ...data };

    const quantity = parseFloat(updatedData.quantity) || 0;
    const rate = parseFloat(updatedData.rate) || 0;
    const bufferRate = parseFloat(updatedData.buffer_rate || 0);
    const marginRate = parseFloat(updatedData.margin_rate_percentage || 0);
    const wiRate = parseFloat(updatedData.wi_rate || 0);
    const costEscalationPercentage = parseFloat(updatedData.cost_escalation_percentage || 0);
    const capexInterestRate = parseFloat(updatedData.capex_interest_rate_percentage || 0);
    const capexMaintenanceRate = parseFloat(updatedData.capex_maintenance || 0);
    const capexInsuranceRate = parseFloat(updatedData.capex_insurance_percentage || 0);

    const grossValue = quantity * rate;
    updatedData.gross_value = grossValue.toFixed(2);

    const costPeriod = parseFloat(updatedData.cost_period || 1);
    const basicCostValue = grossValue / costPeriod;
    updatedData.basic_cost_value = basicCostValue.toFixed(2);

    const costEscalation = basicCostValue * (costEscalationPercentage / 100);
    updatedData.cost_escalation = costEscalation.toFixed(2);

    const capexCostInterest = (grossValue * capexInterestRate) / 100;
    updatedData.capex_cost_interest = capexCostInterest.toFixed(2);

    const costMaintenance = (grossValue * capexMaintenanceRate / 100) / 12;
    updatedData.cost_maintenance = costMaintenance.toFixed(2);

    const costInsurance = (grossValue * capexInsuranceRate / 100) / 12;
    updatedData.cost_insurance = costInsurance.toFixed(2);

    const costBuffer = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance) * (bufferRate / 100);
    updatedData.cost_buffer = costBuffer.toFixed(2);

    const costMargin = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer) * (marginRate / 100);
    updatedData.cost_margin = costMargin.toFixed(2);

    const costWI = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer) * (wiRate / 100);
    updatedData.cost_wi = costWI.toFixed(2);

    const costWithBufferMonth = basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer + costMargin;
    updatedData.cost_with_buffer_month = costWithBufferMonth.toFixed(2);

    const costWithoutBufferMonth = basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costMargin;
    updatedData.cost_without_buffer_month = costWithoutBufferMonth.toFixed(2);

    const period = parseFloat(updatedData.period || 1);
    updatedData.cost_with_buffer_period = (costWithBufferMonth * period).toFixed(2);
    updatedData.cost_without_buffer_period = (costWithoutBufferMonth * period).toFixed(2);

    return updatedData;
  };

  const NUMERIC_ONLY_FIELDS = new Set([
    'cost_period', 'quantity', 'rate',
    'cost_escalation_percentage', 'capex_interest_rate_percentage',
    'capex_maintenance', 'capex_insurance_percentage',
    'buffer_rate', 'wi_rate', 'margin_rate_percentage'
  ]);

  const sanitizeNumericInput = (value) => {
    let cleaned = value.replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) cleaned = parts[0] + '.' + parts.slice(1).join('');
    return cleaned;
  };

  const handleInputChange = (e, field) => {
    let value = e.target.value;
    if (NUMERIC_ONLY_FIELDS.has(field)) {
      value = sanitizeNumericInput(value);
    }
    setEditingData(calculateDerivedFields({ ...editingData, [field]: value }));
  };

  const togglePopup = (index = null) => {
    if (index !== null) {
      const freshElement = categories[selectedCategoryIndex]?.elementlist[index];
      setEditingIndex(index);
      setEditingData({ ...freshElement });
    }
    setShowPopup(prev => !prev);
  };


  const handleAddRow = () => {
    if (selectedCategoryIndex === null) {
      toast.error("Please select a category first");
      return;
    }

    const newElement = {
      element: "",
      cost_period: "",
      element_remarks: "",
      quantity: "",
      cost_maintenance: "",
      wi_rate: "",
      cost_margin: "",
      cost_escalation_percentage: "",
      cost_escalation: "",
      margin_rate_percentage: "",
      cost_with_buffer_month: "",
      capex_maintenance: "",
      cost_buffer: "",
      basic_cost_value: "",
      cost_without_buffer_month: "",
      buffer_rate: "",
      gross_value: "",
      capex_cost_interest: "",
      cost_with_buffer_period: "",
      rate: "",
      capex_interest_rate_percentage: "",
      cost_insurance: "",
      cost_without_buffer_period: "",
      capex_insurance_percentage: "",
      cost_wi: ""
    };

    dispatch(addElement({
      categoryIndex: selectedCategoryIndex,
      element: newElement
    }));
  };


  const loadCostElementOptions = async (inputValue, callback) => {
    try {
      const currentCategory = categories[selectedCategoryIndex];
      const res = await axiosInstance.get(
        `/costsolution/costelement/autosuggestion`,
        {
          params: {
            term: inputValue || '',
            categoryid: currentCategory?.categoryId || '' // Pass the category ID
          }
        }
      );

      const costelement = res.data?.autosuggestion || [];
      const mapped = costelement.map((item) => ({
        label: item.code ? `${item.code} - ${item.label}` : item.label,
        value: item.value,
        code: item.code || ''
      }));

      callback(mapped);
    } catch (error) {
      console.error("Cost element suggestion error:", error);
      callback([]);
    }
  };

  const handleSave = () => {

    if (!validateRowMandatoryFields(editingData)) return;

    if (selectedCategoryIndex !== null && editingIndex !== null) {
      dispatch(updateElement({
        categoryIndex: selectedCategoryIndex,
        elementIndex: editingIndex,
        element: editingData
      }));
    }
    setShowPopup(false);
  };

  useEffect(() => {
    const loadTemplateData = async () => {
      if (!location.state?.templateId || projectPeriodOptions.length === 0) return;

      const isReturningFromSubcost = sessionStorage.getItem('subcostFlowActive') === 'true' || sessionStorage.getItem('subcostReturnData');
      if (isReturningFromSubcost) return;

      console.log("Fetching template with ID:", location.state.templateId);

      try {
        const response = await axiosInstance.get(
          `/costsolution/templatecostlines/get/${location.state.templateId}`
        );

        const template = response.data.costlinestructurevalues;
        setTemplateName(template.templateName);
        setEffectiveDate(template.effectiveDate);
        setSelectedModel(template.model);

        const periodId = template.periodId ||
          (template.templateProjects?.[0]?.project_period || null);

        setProjectPeriod(periodId);

        const periodDetails = projectPeriodOptions.find(opt => opt.value === periodId);
        setSelectedProjectPeriodDetails(periodDetails);

        if (template.templateProjects?.length > 0) {
          const categoriesMap = new Map();

          template.templateProjects.forEach((p) => {
            if (!categoriesMap.has(p.categoryId)) {
              categoriesMap.set(p.categoryId, {
                categoryId: p.categoryId,
                categoryCode: p.categoryCode,
                categoryName: p.categoryName,
                elementlist: []
              });
            }

            const rawElement = {
              element: p.costElementName,
              costElementId: p.costElementId,
              costElementCode: p.costElementCode,
              cost_period: p.costPeriod,
              element_remarks: p.elementRemarks,
              quantity: p.quantity,
              rate: p.rate,
              quantitySetup: p.quantitySetup || "",
              rateSetup: p.rateSetup || "",
              buffer_rate: p.bufferRate,
              cost_escalation_percentage: p.costEscalationPercentage,
              capex_interest_rate_percentage: p.interestRate,
              capex_maintenance: p.capexMaintenance,
              capex_insurance_percentage: p.capexInsurance,
              margin_rate_percentage: p.marginRate,
              wi_rate: p.wiRate,
              period: p.period || periodDetails?.period || 1
            };

            const calculatedElement = calculateDerivedFields(rawElement);

            categoriesMap.get(p.categoryId).elementlist.push(calculatedElement);
          });
          const groupedCategories = Array.from(categoriesMap.values());
          dispatch(setCategories(JSON.parse(JSON.stringify(groupedCategories))));
        } else {
          console.warn("No template projects found.");
        }
      } catch (error) {
        console.error("Failed to load template:", error);
      }
    };

    loadTemplateData();
  }, [location.state?.templateId, projectPeriodOptions]);

  const validateMandatoryFields = () => {
    const missing = [];
    if (!templateName?.trim()) missing.push("Template Name");
    if (!selectedModel) missing.push("Model");
    if (!effectiveDate) missing.push("Effective Date");
    if (!projectPeriod) missing.push("Project Period");

    if (missing.length > 0) {
      toast.error(`Please fill required field(s): ${missing.join(", ")}`);
      return false;
    }
    return true;
  };

  const validateRowMandatoryFields = (data) => {
    const missing = [];
    if (!data.element?.trim()) missing.push("Element");
    if (!data.quantity?.toString().trim()) missing.push("Quantity");
    if (!data.rate?.toString().trim()) missing.push("Rate");

    if (missing.length > 0) {
      toast.error(`Please fill required field(s): ${missing.join(", ")}`);
      return false;
    }
    return true;
  };

  const handleCopyCategory = (categoryIndex) => {
    const category = categories[categoryIndex];
    if (!category) return;
    const snapshot = JSON.parse(JSON.stringify(category.elementlist || []));
    setCopiedCategoryData(snapshot);
    try {
      sessionStorage.setItem('template_copiedCategoryData', JSON.stringify(snapshot));
    } catch (err) {
      console.error('Failed to persist copied category data:', err);
    }
    toast.success(`Copied "${category.categoryName}" category data!`);
  };

  const handlePasteCategory = (categoryIndex) => {
    if (!copiedCategoryData || copiedCategoryData.length === 0) {
      toast.error("No category data copied to paste!");
      return;
    }
    dispatch(pasteCategoryElements({
      categoryIndex,
      elements: copiedCategoryData
    }));
    setCategoryDropdownVisibleFor(null);
    toast.success("Pasted category data!");
  };


  const prepareTemplateData = () => {

    const modelLabel = modelOptions.find(m => m.value === Number(selectedModel))?.label || "";
    const templateProjects = categories.flatMap(category =>
      category.elementlist.map(element => ({
        id: '0',
        template_name: templateName,
        templateBox: true,
        costLineId: 0,
        grossValue: element.gross_value || "0",
        costLinesStructureId: null,
        categoryId: category.categoryId,
        categoryCode: category.categoryCode || "",
        categoryName: category.categoryName || "",
        costElementId: element.costElementId || 0,
        costElementCode: element.costElementCode || "",
        costElementName: element.element || "",
        costTypeId: null,
        costTypeCode: null,
        costTypeName: null,
        period: selectedProjectPeriodDetails?.period || 1,
        projectPeriod: projectPeriod || 0,
        quantity: element.quantity || "0",
        rate: element.rate || "0",
        wiRate: element.wi_rate || "0",
        costWI: element.cost_wi || "0",
        quantitySetup: element.quantitySetup || "",
        rateSetup: element.rateSetup || "",
        bufferRate: element.buffer_rate || "0",
        costEscalationPercentage: element.cost_escalation_percentage || "0",
        interestRate: element.capex_interest_rate_percentage || "0",
        costPeriod: element.cost_period || "1",
        capexMaintenance: element.capex_maintenance || "0",
        capexInsurance: element.capex_insurance_percentage || "0",
        basicCostValue: element.basic_cost_value || "0",
        costEscalation: element.cost_escalation || "0",
        costInterest: element.capex_cost_interest || "0",
        costMaintenance: element.cost_maintenance || "0",
        costInsurance: element.cost_insurance || "0",
        costBuffer: element.cost_buffer || "0",
        marginRate: element.margin_rate_percentage || "0",
        costMargin: element.cost_margin || "0",
        costValueWithBufferMonth: element.cost_with_buffer_month || "0",
        costValueWithoutBufferMonth: element.cost_without_buffer_month || "0",
        costValueWithBufferPeriod: element.cost_with_buffer_period || "0",
        costValueWithoutBufferPeriod: element.cost_without_buffer_period || "0",
        elementRemarks: element.element_remarks || ""
      }))
    );

    return {
      id: location.state?.templateId || "",
      templateBox: true,
      template_name: templateName,
      effectiveDate: effectiveDate,
      projectPeriod: projectPeriod,
      modifieddate: new Date().toISOString().split('T')[0],
      model: selectedModel,
      modelCode: modelLabel,
      templateProjects: templateProjects
    };
  };

  const handleSaveTemplate = async () => {

    if (!validateMandatoryFields()) return;

    try {
      const templateData = prepareTemplateData();
      console.log("Saving template data:", templateData);

      let response;
      if (templateData.id) {
        // Update existing template
        response = await axiosInstance.put(
          `/costsolution/templatecostlines/${templateData.id}`,
          templateData
        );
      } else {
        // Create new template
        response = await axiosInstance.post(
          '/costsolution/templatecostlines',
          templateData
        );
      }

      if (response.status === 200 || response.status === 201) {
        toast.success("Template saved successfully!");
        dispatch(resetCategories());
        setCopiedCategoryData(null);
        sessionStorage.removeItem('template_copiedCategoryData');
        setTimeout(() => navigate(-1), 1200);
      } else {
        toast.error("Failed to save template");
      }
    } catch (error) {
      console.error("Error saving template:", error);
      toast.error("Error saving template: " + (error.response?.data?.message || error.message));
    }
  };


  const handleDeleteRow = (e, subIndex) => {
    e.stopPropagation();
    if (selectedCategoryIndex === null) return;
    setPendingDeleteIndex(subIndex);
    setShowDeleteConfirm(true);
  };

  const confirmDeleteRow = () => {
    if (selectedCategoryIndex !== null && pendingDeleteIndex !== null) {
      dispatch(deleteElement({
        categoryIndex: selectedCategoryIndex,
        elementIndex: pendingDeleteIndex
      }));
      toast.success("Row deleted successfully!");
    }
    setShowDeleteConfirm(false);
    setPendingDeleteIndex(null);
  };

  const cancelDeleteRow = () => {
    setShowDeleteConfirm(false);
    setPendingDeleteIndex(null);
  };


  return (
    <>
      <Header onSearch={null} disableSearch={true} />
      <div className='template-creation'>
        <div className='template-creation-header'>
          <div className='template-creation-left-header'>
            <img
              src={back_arrow}
              alt="Back Arrow"
              onClick={() => {
                dispatch(resetCategories());
                setCopiedCategoryData(null);
                sessionStorage.removeItem('template_copiedCategoryData');
                navigate(-1);
              }}
              style={{ cursor: "pointer" }}
            />
            <p className="new_cost_line" style={{ fontSize: '14px' }}>
              New Template
            </p>
          </div>
          <div className='template-creation-right-header'>
            <button
              className="cancel_btn"
              onClick={() => {
                dispatch(resetCategories());
                setCopiedCategoryData(null);
                sessionStorage.removeItem('template_copiedCategoryData');
                navigate(-1);
              }}
            >
              Cancel
            </button>
            <button className="submit_btn" onClick={handleSaveTemplate}>Save</button>
          </div>
        </div>

        <div className='template-creation-inputbox-content'>
          <div className="template-creation-grid-container" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))',
            gap: '13px',
            padding: '20px',
          }}>

            {/* Template Name */}
            <div className="template-creation-field" style={{ display: 'flex', flexDirection: 'column' }}>
              <label className="template-creation-text" style={{ marginBottom: '6px', fontWeight: 500 }}>Template Name <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={templateName}
                onChange={(e) => setTemplateName(e.target.value)}
                style={{
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '12px',
                  fontSize: '14px',
                  outline: 'none',
                  margin: '0px',
                  fontFamily: 'Work Sans',
                }}
                placeholder="Enter template name"
              />
            </div>

            {/* Model Dropdown */}
            <div className="template-creation-field" style={{ display: 'flex', flexDirection: 'column' }}>
              <label className="template-creation-text" style={{ marginBottom: '6px', fontWeight: 500 }}>Model <span style={{ color: 'red' }}>*</span></label>
              <select
                value={selectedModel}
                onChange={(e) => {
                  setSelectedModel(e.target.value);
                  setCopiedCategoryData(null);
                  sessionStorage.removeItem('template_copiedCategoryData');
                }}
                style={{
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '12px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#fff',
                  fontFamily: 'Work Sans',
                }}
              >
                <option value="" disabled>Select</option>
                {modelOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Effective Date */}
            <div className="template-creation-field" style={{ display: 'flex', flexDirection: 'column' }}>
              <label className="template-creation-text" style={{ marginBottom: '6px', fontWeight: 500 }}>Effective Date <span style={{ color: 'red' }}>*</span></label>
              <input
                type="date"
                value={effectiveDate}
                onChange={(e) => setEffectiveDate(e.target.value)}
                style={{
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '12px',
                  fontSize: '14px',
                  outline: 'none',
                  fontFamily: 'Work Sans'
                }}
              />
            </div>

            {/* Project Period */}
            <div className="template-creation-field" style={{ display: 'flex', flexDirection: 'column' }}>
              <label className="template-creation-text" style={{ marginBottom: '6px', fontWeight: 500 }}>Project Period <span style={{ color: 'red' }}>*</span></label>
              <Select
                options={projectPeriodOptions}
                value={projectPeriodOptions.find(option => option.value === projectPeriod)}
                onChange={handleProjectPeriodChange}
                placeholder="Search project period..."
                isClearable
                styles={{
                  control: (base, state) => ({
                    ...base,
                    border: '1px solid #ccc',
                    borderRadius: '12px',
                    padding: '2px',
                    fontSize: '13px',
                    boxShadow: state.isFocused ? '0 0 0 2px #2684FF22' : 'none',
                    height: '37px',
                    fontFamily: 'Work Sans',
                  }),
                  container: (base) => ({ ...base, width: '100%' }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#888',
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? '#f0f8ff' : '#fff',
                    color: '#333',
                    padding: '10px 12px',
                    cursor: 'pointer',
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    fontSize: '12px',
                    fontFamily: 'Work Sans',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: '#333',
                  }),
                }}
              />
            </div>
          </div>

        </div>

        <div className="categorylistdetails" style={{ backgroundColor: 'white', padding: '13px' }}>
          <div className="categoriesdetails">
            {categories?.map((category, index) => (
              <div key={category.id} className="category_item">
                <div
                  className={`category_header ${selectedCategoryIndex === index ? "Selected" : ""}`}
                  onClick={() => dispatch(selectCategory(index))}
                >
                  <span className="category_name">{category.categoryName}</span>
                  <span className="category_header_actions">
                    <button
                      type="button"
                      className="category_icon_btn"
                      title="Copy category"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopyCategory(index);
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <rect x="9" y="9" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="category_icon_btn"
                      title={copiedCategoryData ? "Paste category here" : "Copy a category first"}
                      disabled={!copiedCategoryData}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePasteCategory(index);
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" strokeWidth="2" />
                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </button>
                    <span className="dropdown_arrow">
                      {selectedCategoryIndex === index ? '▼' : '▶'}
                    </span>
                  </span>
                </div>

                {selectedCategoryIndex === index && (
                  <div className="sub_header" style={{ backgroundColor: '#EDF3F9' }}>
                    <div className="scrollable-container">
                      <table className="element_list">
                        <thead>
                          <tr className="element_details_header">
                            <th className="element_header_column" style={{ minWidth: '50px', width: '50px' }}></th>
                            <th className="element_header_column" style={{ minWidth: '50px', width: '50px' }}>S.NO</th>
                            <th className="element_header_column">PERIOD</th>
                            <th className="element_header_column">ELEMENT <span style={{ color: 'red' }}>*</span></th>
                            <th className="element_header_column element_remarks_column">ELEMENT REMARKS</th>
                            <th className="element_header_column">COST PERIOD</th>
                            <th className="element_header_column">QUANTITY <span style={{ color: 'red' }}>*</span></th>
                            <th className="element_header_column">RATE <span style={{ color: 'red' }}>*</span></th>
                            <th className="element_header_column">GROSS VALUE</th>
                            <th className="element_header_column">MARGIN RATE %</th>
                            <th className="element_header_column">WI RATE %</th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST ESCALATION PERCENTAGE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_ESCALATION_PERCENTAGE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                CAPEX INTEREST RATE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_INTEREST_RATE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                CAPEX MAINTENANCE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_MAINTENANCE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                CAPEX INSURANCE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_INSURANCE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">BUFFER RATE</th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                BASIC COST VALUE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.BASIC_COST_VALUE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST ESCALATION
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_ESCALATION, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                CAPEX COST INTEREST
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_COST_INTEREST, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST MAINTENANCE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_MAINTENANCE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST INSURANCE
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_INSURANCE, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST BUFFER
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_BUFFER, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST MARGIN
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_MARGIN, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST WI
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WI, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST WITH BUFFER(MONTH)
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITH_BUFFER_MONTH, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST W/O BUFFER(MONTH)
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITHOUT_BUFFER_MONTH, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST WITH BUFFER(PERIOD)
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITH_BUFFER_PERIOD, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                            <th className="element_header_column">
                              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                COST W/O BUFFER(PERIOD)
                                <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITHOUT_BUFFER_PERIOD, e)}
                                  onMouseLeave={handleFormulaLeave} />
                              </span>
                            </th>
                          </tr>
                          {tooltip.visible && (
                            <div style={tooltipStyle}>
                              {tooltip.content}
                            </div>
                          )}
                        </thead>
                        <tbody>
                          {categories[selectedCategoryIndex]?.elementlist.map((sub, subIndex) => (
                            <tr key={subIndex} className="element_details_row">
                              <td className="element_value_row" style={{ minWidth: '50px', width: '50px' }}>
                                <img
                                  src={delete_icon}
                                  alt="Delete row"
                                  onClick={(e) => handleDeleteRow(e, subIndex)}
                                  style={{ cursor: 'pointer', width: '27px', height: '27px' }}
                                  title="Delete this row"
                                />
                              </td>
                              <td className="element_value_row" style={{ minWidth: '50px', width: '50px' }}>{subIndex + 1}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>
                                {selectedProjectPeriodDetails?.period || ''}
                              </td>
                              <td
                                className="element_value_row"
                                onClick={() => togglePopup(subIndex, sub)}
                                title={sub.costElementCode ? `${sub.costElementCode} - ${sub.element}` : sub.element}
                              >
                                <span className="cell-text-truncate">
                                  {sub.costElementCode ? `${sub.costElementCode} - ${sub.element}` : sub.element}
                                </span>
                              </td>
                              <td
                                className="element_value_row element_remarks_column"
                                onClick={() => togglePopup(subIndex, sub)}
                                title={sub.element_remarks}
                              >
                                <span className="cell-text-truncate">{sub.element_remarks}</span>
                              </td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_period}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                  {sub.quantity}
                                  <img
                                    src={subcostlinearrow}
                                    alt="arrow"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSubcostlineArrowClick(e, 'quantity', sub, subIndex);
                                    }}
                                    style={{ cursor: 'pointer', marginLeft: '5px' }}
                                  />
                                </span>
                              </td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                  {sub.rate}
                                  <img
                                    src={subcostlinearrow}
                                    alt="arrow"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSubcostlineArrowClick(e, 'rate', sub, subIndex);
                                    }}
                                    style={{ cursor: 'pointer', marginLeft: '5px' }}
                                  />
                                </span>
                              </td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.gross_value}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.margin_rate_percentage}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.wi_rate}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_escalation_percentage}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_interest_rate_percentage}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_maintenance}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_insurance_percentage}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.buffer_rate}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.basic_cost_value}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_escalation}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_cost_interest}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_maintenance}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_insurance}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_buffer}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_margin}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_wi}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_with_buffer_month}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_without_buffer_month}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_with_buffer_period}</td>
                              <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_without_buffer_period}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="add_new_row" onClick={handleAddRow}>
                      <span className="add_new_row_popup"><img src={plus_icon} alt="" />Add Row</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {showPopup && (
          <div
            className="popup-overlay"
            onClick={() => {
              togglePopup();
              setShowPopup(false);
              sessionStorage.removeItem('popupState');
            }}
          >

            <div className="popup-box" onClick={(e) => e.stopPropagation()} style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
              <div className="popup-element-header">
                <p>{`Category ${selectedCategoryIndex + 1} - ${categories[selectedCategoryIndex]?.name || ''
                  } / ${getOrdinal(editingIndex + 1)} Row`}</p>

                <button
                  className="x-btn"
                  onClick={() => togglePopup()}
                  aria-label="Close"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'transparent',
                    border: 'none',
                    borderRadius: '6px',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    color: '#475867',
                    transition: 'background-color 0.15s ease, color 0.15s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#F0F2F5';
                    e.currentTarget.style.color = '#19324C';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#475867';
                  }}
                >
                  <X size={18} strokeWidth={2} />
                </button>
              </div>
              <div className="popup-grid-container">
                <div className="popup-grid-row">
                  <div className="popup-grid-item">
                    <label>Period</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={selectedProjectPeriodDetails?.period || ''}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Element <span style={{ color: 'red' }}>*</span></label>
                    <div style={{ margin: '0px' }}>
                      <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={loadCostElementOptions}
                        onChange={(selectedOption) => {
                          const newData = {
                            ...editingData,
                            element: selectedOption ? selectedOption.label.replace(/^.*? - /, '') : '',
                            element_value: selectedOption ? selectedOption.value : '',
                            costElementId: selectedOption ? selectedOption.value : '',
                            costElementCode: selectedOption ? selectedOption.code : '',
                          };
                          setEditingData(newData);
                        }}
                        value={editingData.element ? {
                          label: editingData.costElementCode
                            ? `${editingData.costElementCode} - ${editingData.element}`
                            : editingData.element,
                          value: editingData.element_value || editingData.element
                        } : null}
                        placeholder="Search ..."
                        isClearable
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: '20px',
                            height: '30px',
                            borderRadius: '8px',
                            fontSize: '13px',
                            borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                            boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                            '&:hover': {
                              borderColor: '#454CF2'
                            }
                          }),
                          container: (base) => ({ ...base, width: '100%' }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 999,
                            fontSize: '12px',
                            marginTop: '4px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: '#999',
                            fontSize: '13px',
                            margin: 0,
                            position: 'absolute',
                            top: '50%',
                            transform: 'translateY(-50%)'
                          }),
                          input: (base) => ({
                            ...base,
                            padding: '0 8px',
                            margin: 0,
                            height: '28px'
                          }),
                          singleValue: (base) => ({
                            ...base,
                            fontSize: '13px',
                            paddingLeft: '8px',
                            margin: 0
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: '4px'
                          }),
                          clearIndicator: (base) => ({
                            ...base,
                            padding: '4px'
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Period</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px' }}
                      value={editingData.cost_period || ''}
                      onChange={(e) => handleInputChange(e, 'cost_period')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Element Remarks</label>
                    <input
                      type="text"
                      style={{ margin: '0px' }}
                      value={editingData.element_remarks || ''}
                      onChange={(e) => handleInputChange(e, 'element_remarks')}
                    />
                  </div>
                </div>

                <div className="popup-grid-row">
                  <div className="popup-grid-item">
                    <label>Quantity <span style={{ color: 'red' }}>*</span></label>
                    <span className="input-with-icon-inside">
                      <input
                        type="text"
                        inputMode="decimal"
                        style={{ margin: '0px' }}
                        value={editingData?.quantity || ''}
                        onChange={(e) => handleInputChange(e, 'quantity')}
                      />
                      <img
                        src={subcostlinearrow}
                        alt="arrow"
                        width={16}
                        height={16}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSubcostlineArrowClick(e, 'quantity', editingData, editingIndex);
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                    </span>
                  </div>
                  <div className="popup-grid-item">
                    <label>Rate <span style={{ color: 'red' }}>*</span></label>
                    <span className="input-with-icon-inside">
                      <input
                        type="text"
                        inputMode="decimal"
                        style={{ margin: '0px' }}
                        value={editingData?.rate || ''}
                        onChange={(e) => handleInputChange(e, 'rate')}
                      />
                      <img
                        src={subcostlinearrow}
                        alt="arrow"
                        width={16}
                        height={16}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSubcostlineArrowClick(e, 'rate', editingData, editingIndex);
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                    </span>
                  </div>
                  <div className="popup-grid-item">
                    <label>Gross Value</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.gross_value || ''}
                      onChange={(e) => handleInputChange(e, 'gross_value')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Basic Cost Value</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.basic_cost_value || ''}
                      onChange={(e) => handleInputChange(e, 'basic_cost_value')}
                      readOnly
                    />
                  </div>
                </div>

                <div className="popup-grid-row">
                  <div className="popup-grid-item">
                    <label>Cost Escalation %</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px' }}
                      value={editingData?.cost_escalation_percentage || ''}
                      onChange={(e) => handleInputChange(e, 'cost_escalation_percentage')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Escalation</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_escalation || ''}
                      onChange={(e) => handleInputChange(e, 'cost_escalation')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Capex Interest Rate %</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px' }}
                      value={editingData?.capex_interest_rate_percentage || ''}
                      onChange={(e) => handleInputChange(e, 'capex_interest_rate_percentage')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Maintenance</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_maintenance || ''}
                      readOnly
                    />
                  </div>
                </div>

                <div className="popup-grid-row">
                  <div className="popup-grid-item">
                    <label>Capex Maintenance %</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px' }}
                      value={editingData?.capex_maintenance || ''}
                      onChange={(e) => handleInputChange(e, 'capex_maintenance')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Maintenance %</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_maintenance_percentage || ''}
                      onChange={(e) => handleInputChange(e, 'cost_maintenance_percentage')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Capex Insurance %</label>
                    <input
                      type="text"
                      style={{ margin: '0px' }}
                      inputMode="decimal"
                      value={editingData?.capex_insurance_percentage || ''}
                      onChange={(e) => handleInputChange(e, 'capex_insurance_percentage')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Insurance</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_insurance || ''}
                      onChange={(e) => handleInputChange(e, 'cost_insurance')}
                      readOnly
                    />
                  </div>
                </div>

                <div className="popup-grid-row">
                  <div className="popup-grid-item">
                    <label>Buffer Rate %</label>
                    <input
                      type="text"
                      style={{ margin: '0px' }}
                      inputMode="decimal"
                      value={editingData?.buffer_rate || ''}
                      onChange={(e) => handleInputChange(e, 'buffer_rate')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Buffer</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_buffer || ''}
                      onChange={(e) => handleInputChange(e, 'cost_buffer')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>WI Rate %</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      style={{ margin: '0px' }}
                      value={editingData?.wi_rate || ''}
                      onChange={(e) => handleInputChange(e, 'wi_rate')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost WI</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_wi || ''}
                      onChange={(e) => handleInputChange(e, 'cost_wi')}
                      readOnly
                    />
                  </div>
                </div>

                <div className="popup-grid-row">
                  <div className="popup-grid-item">
                    <label>Margin Rate %</label>
                    <input
                      type="text"
                      style={{ margin: '0px' }}
                      inputMode="decimal"
                      value={editingData?.margin_rate_percentage || ''}
                      onChange={(e) => handleInputChange(e, 'margin_rate_percentage')}
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost Margin</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_margin || ''}
                      onChange={(e) => handleInputChange(e, 'cost_margin')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost with Buffer (Month)</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_with_buffer_month || ''}
                      onChange={(e) => handleInputChange(e, 'cost_with_buffer_month')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost without Buffer (Month)</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_without_buffer_month || ''}
                      onChange={(e) => handleInputChange(e, 'cost_without_buffer_month')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost with Buffer (Period)</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_with_buffer_period || ''}
                      onChange={(e) => handleInputChange(e, 'cost_with_buffer_period')}
                      readOnly
                    />
                  </div>
                  <div className="popup-grid-item">
                    <label>Cost without Buffer (Period)</label>
                    <input
                      type="text"
                      style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                      value={editingData?.cost_without_buffer_period || ''}
                      onChange={(e) => handleInputChange(e, 'cost_without_buffer_period')}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="done-btn">
                <button onClick={handleSave}>Done</button>
              </div>
            </div>
          </div>
        )}
        <CommonFooter />
        <ConfirmDialog
          open={showDeleteConfirm}
          title="Delete Row"
          message="Are you sure you want to delete this row? This action cannot be undone."
          confirmText="Delete"
          cancelText="Cancel"
          onConfirm={confirmDeleteRow}
          onCancel={cancelDeleteRow}
        />
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      </div>
    </>
  )
}

export default TemplateCreation;

